//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "msgDailog",
    props:{
      title:{ //标题
        type: String,
        default: ""
      },
      placeholderText:{//文本域提示信息
        type: String,
        default: ""
      },
      ifcancel:{
        type: Boolean,
        default:false,
      }
    },
    data(){
      return {
        showIcon:true,
        showTitle:true,
        show:true,
        isShowMessageBox: false,
        myData:'',
        resolve: '',
        reject: '',
        promise: '', // 保存promise对象
      }
    },
    updated(){
      this.initMsg()
    },
    methods:{
      initMsg(){

      },
      // 确定,将promise断定为resolve状态
      confirm: function () {
        this.isShowMessageBox = false;
        this.resolve(this.myData);
        this.remove();
      },
      // 取消,将promise断定为reject状态
      cancel: function () {
        this.isShowMessageBox = false;
        this.reject('cancel');
        this.remove();
      },
      // 弹出messageBox,并创建promise对象
      showMsgBox: function () {
        this.isShowMessageBox = true;
        this.promise = new Promise((resolve, reject) => {
          this.resolve = resolve;
          this.reject = reject;
        });
        // 返回promise对象
        return this.promise;
      },
      remove: function () {
        setTimeout(() => {
          this.destroy();
        }, 300);
      },
      destroy: function () {
        this.$destroy();
        document.body.removeChild(this.$el);
      }
    }
}



// WEBPACK FOOTER //
// ./src/pcpage/hr/recruitment/portal/component/msgDailog/msgDailog.vue